<template>
  <div class="bg-white px-3 py-4 shadow rounded-4 w-100 h-100 mb-4">
    <div class="mb-3">
      <div class="widget-header">
        <div class="widget-header__title">
          <span>
            {{ title }}
            <span v-if="tooltipText" :id="`${title} tooltip-info`">
              <i class="mc-fa icon-outline_info"></i>
            </span>
          </span>
          <b-tooltip
            v-if="tooltipText"
            :target="`${title} tooltip-info`"
            triggers="hover"
            placement="bottomRight"
          >
            {{ tooltipText }}
          </b-tooltip>
          <div v-if="$slots['subTitle']" class="widget-header__subtitle">
            <slot name="subTitle" />
          </div>
          <p v-else-if="subTitle" class="mb-0 widget-header__subtitle">{{ subTitle }}</p>
        </div>
        <div v-if="$slots['afterTitle']" class="widget-header__content">
          <slot name="afterTitle" />
        </div>
      </div>
    </div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton height="250px"></b-skeleton>
      </template>
      <slot />
    </b-skeleton-wrapper>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    tooltipText: {
      type: String,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  @include xs-screen-only {
    flex-direction: column;
  }

  &__title {
    span {
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      & > span {
        font-size: 16px;
      }
      color: $mep-color-text;
    }
  }

  &__subtitle {
    font-size: 10px;
    font-weight: 500;
    line-height: 16px;
    margin-top: 0.25rem;
    color: $mep-color-text;
  }

  &__content {
    flex: 1 1 auto;
    display: flex;
    justify-content: end;

    @include xs-screen-only {
      width: 100%;
    }
  }
}
</style>
